import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dashboardLogo from "../../Images/image.png";
import { RiLogoutBoxLine } from "react-icons/ri";
import { message } from "antd";
import { MdDashboard, MdPolicy, MdInfo, MdGavel } from "react-icons/md";
import { FaUsers, FaEnvelope, FaQuestion } from "react-icons/fa";
import { AiTwotoneIdcard } from "react-icons/ai";
import Loader from "../Loader/Loader";
import { CiSettings } from "react-icons/ci";
import { MdOutlinePayment } from "react-icons/md";

const Sidenav = ({ isOpen }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    setLoading(true);
    try {
      localStorage.clear();
      message.success("Successfully logged out");
      setShowLogoutModal(false);
      setTimeout(() => {
        window.location.href = "/admin-panel/login";
      }, 1000);
    } catch (error) {
      console.log("error in log out", error);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`text-white w-64 h-screen p-4 fixed top-0 left-0 transition-transform transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } shadow-lg flex flex-col`}
        style={{
          backgroundColor: "#1E293B", // slate-800
        }}
      >
        {/* Logo */}
        <div
          className="h-20 w-20  rounded-full flex items-center justify-center shadow-md cursor-pointer ml-6"
          onClick={() => navigate("/home")}
        >
          <img src={dashboardLogo} alt="Admin Logo" />
        </div>

        {/* Navigation */}
        <div className="flex-1 overflow-y-auto mt-6">
          <ul className="space-y-2">
            <li>
              <Link
                to="/home"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/home"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <MdDashboard className="text-xl mr-3" />
                <span>Dashboard</span>
              </Link>
            </li>

            <li>
              <Link
                to="/user-management"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/user-management"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <FaUsers className="text-lg mr-3" />
                <span>Users Management</span>
              </Link>
            </li>

            <li>
              <Link
                to="/thank_you_card"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/thank_you_card"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <FaEnvelope className="text-lg mr-3" />
                <span>Thanks Management</span>
              </Link>
            </li>

            <li>
              <Link
                to="/card-management"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/card-management"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <AiTwotoneIdcard className="text-lg mr-3" />
                <span>Card Management</span>
              </Link>
            </li>
            <li>
              <Link
                to="/payments"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/payments"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <MdOutlinePayment className="text-lg mr-3" />
                <span>Payment Management</span>
              </Link>
            </li>

            <li>
              <Link
                to="/FAQ"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/FAQ"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <FaQuestion className="text-lg mr-3" />
                <span>FAQ's</span>
              </Link>
            </li>

            <li>
              <Link
                to="/help"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/help"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <MdInfo className="text-lg mr-3" />
                <span>Help</span>
              </Link>
            </li>

            <li>
              <Link
                to="/terms-conditions"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/terms-conditions"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <MdGavel className="text-lg mr-3" />
                <span>Terms & Conditions</span>
              </Link>
            </li>

            <li>
              <Link
                to="/privacy-policy"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/privacy-policy"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <MdPolicy className="text-lg mr-3" />
                <span>Privacy Policy</span>
              </Link>
            </li>

            <li>
              <Link
                to="/app-setting"
                className={`flex items-center p-3 rounded-lg transition-colors ${
                  location.pathname === "/app-setting"
                    ? "bg-blue-600 text-white"
                    : "hover:bg-slate-700"
                }`}
              >
                <CiSettings className="text-lg mr-3 " />
                <span>App Settings</span>
              </Link>
            </li>
          </ul>
        </div>

        {/* Logout */}
        <div
          onClick={() => setShowLogoutModal(true)}
          className="mt-6 flex items-center p-3 rounded-lg cursor-pointer bg-gradient-to-r from-red-600 to-red-800 hover:shadow-lg transition"
        >
          <RiLogoutBoxLine className="text-lg mr-3" />
          <span className="font-semibold">Logout</span>
        </div>
      </aside>

      {/* Loader */}
      {loading && <Loader />}

      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
            <h3 className="text-2xl font-bold mb-3 text-gray-800">
              Confirm Logout
            </h3>
            <p className="mb-6 text-gray-600">
              Are you sure you want to log out?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="bg-gray-200 text-gray-800 py-2 px-6 rounded-md hover:bg-gray-300 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="bg-red-600 text-white py-2 px-6 rounded-md hover:bg-red-700 transition"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidenav;
